/* NAD theme — global behaviour. No dependencies. */
(function () {
  'use strict';

  /* --- Mobile menu ----------------------------------------------------- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var mobileMenu = document.getElementById('MobileMenu');
  if (toggle && mobileMenu) {
    toggle.addEventListener('click', function () {
      var open = mobileMenu.classList.toggle('open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* --- Age gate -------------------------------------------------------- */
  var gate = document.getElementById('AgeGate');
  if (gate) {
    var days = parseInt(gate.dataset.cookieDays || '30', 10);
    var KEY = 'nad_age_ok';
    var verified = document.cookie.split('; ').some(function (c) {
      return c.indexOf(KEY + '=1') === 0;
    });
    if (verified) {
      gate.remove();
    } else {
      gate.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var accept = gate.querySelector('[data-gate-accept]');
      if (accept) {
        accept.addEventListener('click', function () {
          var d = new Date();
          d.setTime(d.getTime() + days * 864e5);
          document.cookie = KEY + '=1; expires=' + d.toUTCString() + '; path=/; SameSite=Lax';
          gate.remove();
          document.documentElement.style.overflow = '';
        });
        accept.focus();
      }
    }
  }

  /* --- Collection filters: mobile disclosure --------------------------- */
  var fToggle = document.querySelector('[data-filters-toggle]');
  var fPanel = document.getElementById('CollectionFilters');
  if (fToggle && fPanel) {
    var mq = window.matchMedia('(max-width: 900px)');
    var sync = function () {
      if (mq.matches) {
        fPanel.hidden = true;
        fToggle.setAttribute('aria-expanded', 'false');
      } else {
        fPanel.hidden = false;
      }
    };
    sync();
    mq.addEventListener('change', sync);
    fToggle.addEventListener('click', function () {
      fPanel.hidden = !fPanel.hidden;
      fToggle.setAttribute('aria-expanded', fPanel.hidden ? 'false' : 'true');
    });
  }

  /* --- Filter form: auto-submit on change ------------------------------ */
  var filterForm = document.getElementById('CollectionFilterForm');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('input[type=checkbox], select')) filterForm.submit();
    });
  }

  /* --- FAQ table of contents: highlight current section ---------------- */
  var tocLinks = document.querySelectorAll('[data-toc] a');
  if (tocLinks.length && 'IntersectionObserver' in window) {
    var map = {};
    tocLinks.forEach(function (a) { map[a.getAttribute('href').slice(1)] = a; });
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          tocLinks.forEach(function (a) { a.classList.remove('active'); });
          if (map[entry.target.id]) map[entry.target.id].classList.add('active');
        }
      });
    }, { rootMargin: '-120px 0px -70% 0px' });
    Object.keys(map).forEach(function (id) {
      var el = document.getElementById(id);
      if (el) obs.observe(el);
    });
  }

  /* --- FAQ client-side filter ------------------------------------------ */
  var faqInput = document.querySelector('[data-faq-search]');
  if (faqInput) {
    var run = function () {
      var q = faqInput.value.trim().toLowerCase();
      document.querySelectorAll('.faq-group').forEach(function (group) {
        var shown = 0;
        group.querySelectorAll('details').forEach(function (d) {
          var hit = !q || d.textContent.toLowerCase().indexOf(q) !== -1;
          d.hidden = !hit;
          if (hit) shown++;
          if (q && hit) d.open = true;
        });
        group.hidden = shown === 0;
      });
    };
    faqInput.addEventListener('input', run);
    var faqForm = faqInput.closest('form');
    if (faqForm) faqForm.addEventListener('submit', function (e) { e.preventDefault(); run(); });
  }

  /* --- Product cards: "Add to Cart" without leaving the page ----------- */
  /* Only single-variant products render this form (see product-card.liquid).
     Without JS, or if the request fails, the form posts normally to /cart. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-card-add]') || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('button[type=submit]');
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (btn) btn.disabled = false;
        if (res.status) {
          /* Shopify returns an error payload with `status` set (e.g. sold out) */
          window.location.href = root + 'cart';
          return;
        }
        if (window.nadRefreshCartCount) window.nadRefreshCartCount();
        if (btn) {
          btn.textContent = btn.dataset.labelAdded || 'Added ✓';
          setTimeout(function () { btn.textContent = btn.dataset.labelAdd || 'Add to Cart'; }, 1800);
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        form.submit();
      });
  });

  /* --- Content tables: stack on phones ---------------------------------- */
  /* Tables typed into blog posts, pages and policies. Each cell gets its
     column heading as data-label so the phone layout (see nad-theme.css,
     section 24) can show one row per card with "Heading: value" lines.
     Tables with no heading row, or more than six columns, are left alone
     and scroll sideways instead. */
  document.querySelectorAll('.rte table, .shopify-policy__body table').forEach(function (table) {
    if (table.closest('.table-scroll')) return;
    var headRow = (table.tHead && table.tHead.rows[0]) || table.rows[0];
    var heads = headRow ? Array.prototype.map.call(headRow.children, function (c) { return c.textContent.trim(); }) : [];
    /* A heading row is a <thead> row, or a first row made only of <th> cells
       (a single <th> at the start of a row is a row label, not a heading). */
    var hasHeader = !!table.tHead || (headRow && headRow.children.length > 0 && !headRow.querySelector('td'));
    if (table.querySelector('table')) hasHeader = false;
    var spans = table.querySelector('[colspan],[rowspan]');
    if (hasHeader && !spans && heads.length >= 2 && heads.length <= 6) {
      table.classList.add('rte-table--stack');
      headRow.classList.add('rte-table__head');
      Array.prototype.forEach.call(table.rows, function (tr) {
        if (tr === headRow) return;
        Array.prototype.forEach.call(tr.children, function (cell, i) {
          if (heads[i]) cell.setAttribute('data-label', heads[i]);
        });
      });
    }
    var wrap = document.createElement('div');
    wrap.className = 'table-scroll';
    wrap.setAttribute('tabindex', '0');
    wrap.setAttribute('role', 'region');
    wrap.setAttribute('aria-label', 'Table');
    table.parentNode.insertBefore(wrap, table);
    wrap.appendChild(table);
  });

  /* --- Cart count refresh (after any /cart/add.js elsewhere) ----------- */
  window.nadRefreshCartCount = function () {
    fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
      })
      .catch(function () {});
  };
})();
